import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { FiTrash2 } from 'react-icons/fi'
import { HiOutlineRefresh } from 'react-icons/hi'

interface props {
  isWarningSteps?: boolean
  isErrorSteps?: boolean
}

const TestCaseWarningErrorStep = ({
  isWarningSteps = false,
  isErrorSteps = false
}: props) =>
  <Paragraph variant='whitespace-pre-wrap'>
    {
      isWarningSteps &&
        <Color variant='theme-color-tab-label-unselected'>
          Please resolve problems with your steps in step order to ensure appropriate next step suggestion.<br />
        </Color>
    }
    {
      isErrorSteps &&
        <Color
          display='inline'
          variant='theme-color-tab-label-unselected'
        >
          Refreshing a step with an error&nbsp;
          <HiOutlineRefresh
            aria-hidden
            size={16}
          />&nbsp;
          may resolve the error. If an error persists then the step can be removed&nbsp;
          <FiTrash2
            aria-hidden
            size={16}
          />
        </Color>
    }
  </Paragraph>

export default TestCaseWarningErrorStep
